import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Form from 'react-bootstrap/Form'

export default function SearchTab() {
    return <>
        <div className='mt-5 pb-5' >
            <Tabs defaultActiveKey="first">
                <Tab eventKey="first" title="Moving & Packing">
                    <div className='searchSec' >
                        <div className='selectCate' >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.01301 1.8933L2.41967 4.6933C1.81967 5.15997 1.33301 6.1533 1.33301 6.90663V11.8466C1.33301 13.3933 2.59301 14.66 4.13967 14.66H11.8597C13.4063 14.66 14.6663 13.3933 14.6663 11.8533V6.99997C14.6663 6.1933 14.1263 5.15997 13.4663 4.69997L9.34634 1.8133C8.41301 1.15997 6.91301 1.1933 6.01301 1.8933Z" stroke="#050810" stroke-width="1.16091" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8 11.9933V9.99329" stroke="#050810" stroke-width="1.16091" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <Form.Select aria-label="Default select example">
                                <option>Property Type</option>
                                <option value="1">One</option>
                                <option value="3">Three</option>
                            </Form.Select>
                        </div>
                        <div className='searchInput' >
                            <input className='form-control ' placeholder='Furniture Rearranging & Moving...' />
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.66634 14C11.1641 14 13.9997 11.1644 13.9997 7.66665C13.9997 4.16884 11.1641 1.33331 7.66634 1.33331C4.16854 1.33331 1.33301 4.16884 1.33301 7.66665C1.33301 11.1644 4.16854 14 7.66634 14Z" stroke="#050810" stroke-width="1.16091" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M14.6663 14.6666L13.333 13.3333" stroke="#050810" stroke-width="1.16091" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div className='searchBtn' >
                            <button className='btn btn-primary' >Search</button>
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="second" title="Storage">
                    <div className='searchSec' >
                        <div className='selectCate' >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.01301 1.8933L2.41967 4.6933C1.81967 5.15997 1.33301 6.1533 1.33301 6.90663V11.8466C1.33301 13.3933 2.59301 14.66 4.13967 14.66H11.8597C13.4063 14.66 14.6663 13.3933 14.6663 11.8533V6.99997C14.6663 6.1933 14.1263 5.15997 13.4663 4.69997L9.34634 1.8133C8.41301 1.15997 6.91301 1.1933 6.01301 1.8933Z" stroke="#050810" stroke-width="1.16091" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8 11.9933V9.99329" stroke="#050810" stroke-width="1.16091" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <Form.Select aria-label="Default select example">
                                <option>Property Type</option>
                                <option value="1">One</option>
                                <option value="3">Three</option>
                            </Form.Select>
                        </div>
                        <div className='searchInput' >
                            <input className='form-control ' placeholder='Furniture Rearranging & Moving...' />
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.66634 14C11.1641 14 13.9997 11.1644 13.9997 7.66665C13.9997 4.16884 11.1641 1.33331 7.66634 1.33331C4.16854 1.33331 1.33301 4.16884 1.33301 7.66665C1.33301 11.1644 4.16854 14 7.66634 14Z" stroke="#050810" stroke-width="1.16091" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M14.6663 14.6666L13.333 13.3333" stroke="#050810" stroke-width="1.16091" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div className='searchBtn' >
                            <button className='btn btn-primary' >Search</button>
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="third" title="Junk Removal">
                    <div className='searchSec' >
                        <div className='selectCate' >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.01301 1.8933L2.41967 4.6933C1.81967 5.15997 1.33301 6.1533 1.33301 6.90663V11.8466C1.33301 13.3933 2.59301 14.66 4.13967 14.66H11.8597C13.4063 14.66 14.6663 13.3933 14.6663 11.8533V6.99997C14.6663 6.1933 14.1263 5.15997 13.4663 4.69997L9.34634 1.8133C8.41301 1.15997 6.91301 1.1933 6.01301 1.8933Z" stroke="#050810" stroke-width="1.16091" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8 11.9933V9.99329" stroke="#050810" stroke-width="1.16091" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <Form.Select aria-label="Default select example">
                                <option>Property Type</option>
                                <option value="1">One</option>
                                <option value="3">Three</option>
                            </Form.Select>
                        </div>
                        <div className='searchInput' >
                            <input className='form-control ' placeholder='Furniture Rearranging & Moving...' />
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.66634 14C11.1641 14 13.9997 11.1644 13.9997 7.66665C13.9997 4.16884 11.1641 1.33331 7.66634 1.33331C4.16854 1.33331 1.33301 4.16884 1.33301 7.66665C1.33301 11.1644 4.16854 14 7.66634 14Z" stroke="#050810" stroke-width="1.16091" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M14.6663 14.6666L13.333 13.3333" stroke="#050810" stroke-width="1.16091" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div className='searchBtn' >
                            <button className='btn btn-primary' >Search</button>
                        </div>
                    </div>
                </Tab>
            </Tabs>
        </div>
    </>
}



